import FormData from "csi/action/FormData";
import Copy from "csi/table/Copy";
import declare from "dojo/_base/declare";


const CopyShapeController = declare(Copy, {
	/**@override */
	getFormData() {
		// summary: when copying Shape make sure to blank out seasons
		const fd = this.inherited<FormData>(arguments);
		fd.setFieldInitialValue("ShapeSeasons", "");
		return fd;
	},
});

export = CopyShapeController;
